import { QueryFilterOption } from '../models/query-option.model';

export const QUERY_FILTER_OPTIONS = {
  any: new QueryFilterOption('Is Any Of', 'any'),
  not_any: new QueryFilterOption('Is Not Any Of', 'not_any'),
  cts: new QueryFilterOption('Contains', 'cts'),
  not_cts: new QueryFilterOption('Do not contain', 'not_cts'),
  eq: new QueryFilterOption('Is equal to', 'eq'),
  not_eq: new QueryFilterOption('Is not equal to', 'not_eq'),
  begins_with: new QueryFilterOption('Begins with', 'begins_with'),
  ends_with: new QueryFilterOption('Ends with', 'ends_with'),
  na: new QueryFilterOption('Is n/a or empty', 'na'),
  not_na: new QueryFilterOption('Is not n/a or empty', 'not_na'),
  metric_na: new QueryFilterOption('Is n/a', 'na'),
  metric_not_na: new QueryFilterOption('Is not n/a', 'not_na'),
  gt: new QueryFilterOption('Is greater than', 'gt'),
  gte: new QueryFilterOption('Is greater than or equal to', 'gte'),
  lt: new QueryFilterOption('Is less than', 'lt'),
  lte: new QueryFilterOption('Is less than or equal to', 'lte'),
  anything: new QueryFilterOption('Is anything', 'anything'),
  is_in: new QueryFilterOption('Is in', 'is_in'),
  not_is_in: new QueryFilterOption('Is not in', 'not_is_in'),
};

export const METRIC_FILTER_OPTIONS = [
  QUERY_FILTER_OPTIONS.eq,
  QUERY_FILTER_OPTIONS.not_eq,
  QUERY_FILTER_OPTIONS.metric_na,
  QUERY_FILTER_OPTIONS.metric_not_na,
  QUERY_FILTER_OPTIONS.gt,
  QUERY_FILTER_OPTIONS.gte,
  QUERY_FILTER_OPTIONS.lt,
  QUERY_FILTER_OPTIONS.lte,
];

export const QUERY_GLOBAL_OPTION_FILTERS = [
  QUERY_FILTER_OPTIONS.any,
  QUERY_FILTER_OPTIONS.not_any,
  QUERY_FILTER_OPTIONS.cts,
  QUERY_FILTER_OPTIONS.not_cts,
  QUERY_FILTER_OPTIONS.eq,
  QUERY_FILTER_OPTIONS.not_eq,
  QUERY_FILTER_OPTIONS.begins_with,
  QUERY_FILTER_OPTIONS.ends_with,
  QUERY_FILTER_OPTIONS.na,
  QUERY_FILTER_OPTIONS.not_na,
  QUERY_FILTER_OPTIONS.gt,
  QUERY_FILTER_OPTIONS.gte,
  QUERY_FILTER_OPTIONS.lt,
  QUERY_FILTER_OPTIONS.lte,
  QUERY_FILTER_OPTIONS.is_in,
  QUERY_FILTER_OPTIONS.not_is_in,
];

export const QUERY_WIDGET_OPTION_FILTERS = [
  QUERY_FILTER_OPTIONS.any,
  QUERY_FILTER_OPTIONS.not_any,
  QUERY_FILTER_OPTIONS.cts,
  QUERY_FILTER_OPTIONS.not_cts,
  QUERY_FILTER_OPTIONS.eq,
  QUERY_FILTER_OPTIONS.not_eq,
  QUERY_FILTER_OPTIONS.begins_with,
  QUERY_FILTER_OPTIONS.ends_with,
  QUERY_FILTER_OPTIONS.na,
  QUERY_FILTER_OPTIONS.not_na,
  QUERY_FILTER_OPTIONS.gt,
  QUERY_FILTER_OPTIONS.gte,
  QUERY_FILTER_OPTIONS.lt,
  QUERY_FILTER_OPTIONS.lte,
  QUERY_FILTER_OPTIONS.anything,
  QUERY_FILTER_OPTIONS.is_in,
  QUERY_FILTER_OPTIONS.not_is_in,
];

export const EMPTY_VALUES_WARNING = 'emptyValuesWarning';

export const DEFAULT_QUERY_INTERVAL = '19700101-20700101';
